import React, { Component } from 'react';
import Layout from './components/Layout/Layout';
import BurgerBuilder from './containers/BurgerBuilder/BurgerBuildeer';

class App extends Component {
  render() {
    return (
      <div >
        <Layout>
	      <BurgerBuilder/>
        </Layout>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js